// Vendors
import React from 'react';
// Components
import { Illustration } from '@openbank/ziniaweb-ui-components';
// Contexts
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
// Constants
import { LAYOUT_ASSET_COMPONENT_PROPS } from './constants/layout-asset.constants';
// Styles
import { LayoutOperationalAssetComponentStyled } from 'components/layout/components/operational/components/asset/layout-operational-asset.component.styled';
// Types
import { LayoutType } from 'components/layout/types/layout.type';
// Utils
import { isCompactView } from './utils/layout-operational-asset.component.utils';

const LayoutOperationalAssetComponent = ({
  assetId,
}: Pick<LayoutType, 'assetId'>): React.JSX.Element | null => {
  const { compactView } = useLayoutContextConsumerHook();
  return assetId && !isCompactView(compactView) ? (
    <LayoutOperationalAssetComponentStyled>
      <Illustration {...LAYOUT_ASSET_COMPONENT_PROPS} illustration={assetId} />
    </LayoutOperationalAssetComponentStyled>
  ) : null;
};

export { LayoutOperationalAssetComponent };
